import React from "react";
import pretty from "Shared/pretty";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";

const getDateOption = (date: string) => ({
  label: pretty.date(date),
  value: date,
});

export interface DateSelectProps {
  date: string;
  onChangeDate: (newDate: string) => void;
  dates: string[];
  includeSelectAllOption?: boolean;
}

export const DateSelect = ({
  date,
  onChangeDate,
  dates,
  includeSelectAllOption,
}: DateSelectProps) => {
  const dateOptions = (dates || []).map(getDateOption);
  const emptyDateOption = {
    label: "All",
    value: "",
  };
  const allOptions = includeSelectAllOption ? [emptyDateOption, ...dateOptions] : dateOptions;

  return (
    <DPReactSelect
      value={date
        ? getDateOption(date)
        : (includeSelectAllOption ? emptyDateOption : undefined)
      }
      options={allOptions}
      onChange={({ value }: { value: string }) => onChangeDate(value)}
    />
  );
};
